import { Box, styled } from "@mui/material";
import { createShouldForwardPropBlockList } from "@pmag/ui-components";
import { type Maybe } from "@src/graphql.generated";

export interface StyledImageProps {
    url: string;
}

export const StyledImage = styled("span", {
    shouldForwardProp: createShouldForwardPropBlockList(["url"]),
})<StyledImageProps>(({ theme, url }) => ({
    width: 140,
    height: 70,
    backgroundImage: `url(${url})`,
    backgroundSize: "fit",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
}));

export interface CardProps {
    hoverBackground: Maybe<string>;
    hoverUrl: Maybe<string>;
}

export const Card = styled(Box, {
    shouldForwardProp: createShouldForwardPropBlockList(["hoverUrl", "hoverBackground"]),
})<CardProps>(({ theme, hoverUrl, hoverBackground }) => ({
    display: "flex",
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: theme.shape.borderRadius,
    height: 116,
    boxShadow: theme.shadow.boxShadow.sm,
    userSelect: "none",

    "&:hover": {
        boxShadow: theme.shadow.boxShadow.lg,
        cursor: "pointer",
        backgroundColor: hoverBackground,

        ...(hoverUrl &&
            hoverBackground && {
                "& span": {
                    backgroundImage: `url(${hoverUrl})`,
                },
            }),
    },
}));
